import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  hostCompany: string = '';
  androidStoreUrl: string = '';
  iOSStoreUrl: string = '';
  constructor() {
    if (location.origin.endsWith('domii.io')) {
      this.hostCompany = 'domii';
    }
    else if (location.origin.endsWith('cocoearly.com')) {
      this.hostCompany = 'cocoearly';
    }
  }

  

  getAndroidStoreUrl() {
    if (this.hostCompany == 'domii') {
      return 'https://play.google.com/store/apps/details?id=com.ia9.mobile';
    }
    else if (this.hostCompany == 'cocoearly') {
      return 'https://play.google.com/store/apps/details?id=com.ia9.cocoearly';
    }
    else {
      return 'https://play.google.com/store/apps/details?id=com.ia9.mobile';
    }
  }

  getiOSStoreUrl() {
    if (this.hostCompany == 'domii') {
      return 'https://apps.apple.com/us/app/domii/id1467412622';
    }
    else if (this.hostCompany == 'cocoearly') {
      return 'https://apps.apple.com/us/app/cea-search/id1550866357';
    }
    else {
      return 'https://apps.apple.com/us/app/domii/id1467412622';
    }
  }

  /**
   * AC-4594: the domiiRescue consumer app's listings, for the consumer signup page. Until a
   * store's switch (rescuePlayStoreLink / rescueAppStoreLink) is on for an environment
   * (production waits for each store's launch), that store's link is Domii's, as before.
   *
   * With an invite code, the Play link carries it as the install referrer
   * (referrer=code%3D{code}); domiiRescue reads it on first launch and opens signup with the
   * invite filled in. iOS has no equivalent - there the invitee taps the link again.
   */
  getRescueAndroidStoreUrl(inviteCode?: string) {
    if (!environment.rescuePlayStoreLink) {
      return this.getAndroidStoreUrl();
    }
    const url = 'https://play.google.com/store/apps/details?id=com.ia9.rescue';
    return inviteCode
      ? url + '&referrer=' + encodeURIComponent('code=' + inviteCode)
      : url;
  }

  /** Whether domiiRescue's Google Play listing is live for this environment. */
  hasRescuePlayStoreLink(): boolean {
    return !!environment.rescuePlayStoreLink;
  }

  /** Whether domiiRescue's App Store listing is live for this environment. */
  hasRescueAppStoreLink(): boolean {
    return !!environment.rescueAppStoreLink;
  }

  getRescueiOSStoreUrl() {
    return environment.rescueAppStoreLink
      ? 'https://apps.apple.com/app/id6821560379'
      : this.getiOSStoreUrl();
  }

  getFavicon() {
    if (this.hostCompany == 'domii') {
      return 'favicon_domii.ico';
    }
  }

  getTitle() {
    if (this.hostCompany == 'domii') {
      return 'Account Domii';
    }
    else if (this.hostCompany == 'cocoearly') {
      return 'Account Cocoearly';
    }
  }

  getXClientId() {
    if (this.hostCompany == 'domii') {
      return environment.XClientId_Domii;
    }
    else if (this.hostCompany == 'cocoearly') {
      return environment.XClientId_CoCoEarly;
    }
    else {
      return environment.XClientId_Domii;
    }
  }

  getCompanyLogo() {
    if (this.hostCompany == 'domii') {
      return 'domii_logo.svg';
    }
    else if (this.hostCompany == 'cocoearly') {
      return 'coco_early_logo.svg';
    }
    else {
      return 'domii_logo.svg';
    }
  }

  getCompanyBrand() {
    if (this.hostCompany == 'domii') {
      return 'domii_brand_white.svg';
    }
    else if (this.hostCompany == 'cocoearly') {
      return 'coco_early_brand.svg';
    }
    else {
      return 'domii_brand_white.svg';
    }
  }

  getIA9LightningUrl() {
    return environment.IA9LightningUrl;
  }

  getIA9LightningKey() {
    return environment.IA9LightningKey;
  }

  getIA9V2Url() {
    return environment.IA9V2Url;
  }

  getIA9V2Key() {
    return environment.IA9V2Key;
  }

  getIA9CoreUrl() {
    return environment.IA9CoreUrl;
  }

  getIA9CoreKey() {
    return environment.IA9CoreKey;
  }

  getFreeRedirectUrl(){
    return environment.FreeBuyerRedirectUrl;
  }

  getEULAUrl() {
    if (this.hostCompany == 'domii') {
      return environment.EULA_Domii;
    }
    else if (this.hostCompany == 'cocoearly') {
      return environment.EULA_CoCoEarly;
    }
    else {
      return environment.EULA_Domii;
    }
  }

  getPrivacyUrl() {
    if (this.hostCompany == 'domii') {
      return environment.Privacy_Domii;
    }
    else if (this.hostCompany == 'cocoearly') {
      return environment.Privacy_CoCoEarly;
    }
    else {
      return environment.Privacy_Domii;
    }
  }
}
